import { NavigateToEnum } from '@bo-client/activation-management/shared/models/AnswerWithMoreInfoModel';

export const path = {
  // general
  id: '/:id',
  grId: '/:grId',
  technicianId: '/:technicianId',
  installerPassId: '/:installerPassId',
  gridRegType: '/:gridType',
  detail: 'detail',
  oldUiAdaptations: 'uiAdaptations',
  uiAdaptionsAdmin: 'ui-adaptations-admin',
  uiAdaptionsManagement: 'ui-adaptions-management',
  codeListValues: 'codeListValues',
  home: 'home',
  linkChangePsw: '/link/:token/:mail',
  token: '/:token',
  area: '/:area',
  create: '/create',
  external: 'external',
  createDraft: '/createdraft',
  edit: '/edit',
  list: '/list',
  admin: '/admin',
  changePassword: 'changepassword',
  feedback: '/feedback',
  nextActions: 'next-actions',

  // HAP
  hapPrefix: 'hap',
  hapTenantPrefix: 'hap-tenant',
  hapOrders: 'orders',
  hapOrdersV2: 'orders-next',
  hapOrdersEdit: 'orders/edit',
  hapOrderDetail: 'order-request-detail',
  hapOrderDetailFromList: 'order-request-detail-from-list',
  hapBusinessPartner: 'business-partners',
  hapBusinessPartnerDetail: 'business-partners/detail',
  hapCompanyLocations: 'company-locations',
  hapCompanyLocationsDetail: 'company-locations/detail',
  hapDevelopmentAreas: 'development-areas',
  hapDevelopmentAreasDetail: 'development-areas/detail',
  hapTenant: 'tenant',
  hapTenantConfig: 'config',
  hapTenantList: 'tenant-list',
  hapTenantListDetail: 'tenant-list/detail',
  hapUsers: 'users',
  hapUserList: 'user-list',
  hapRoleList: 'roles',

  // HAP - Anschlussänderung
  hapConnectionChange: 'connection-change',
  hapConnectionChangeRequest: 'connection-change-request',
  orderRequestWizard: 'order-request-wizard',

  // Installateur
  privacyPolicy: 'datenschutz',
  termsConditions: 'impressum',
  tmPrefix: 'tm', // Only use on loading children in routing
  tmPath: '/tm/',
  tmHome: 'home',
  tmNewUserActivation: 'activate',
  tmRegistrationThen: 'register',
  tmRegistrationGast: 'registrationgast',
  tmDesktop: 'desktop',
  tmCreateUser: 'user/new',
  tmEditUser: 'user/edit',
  tmUserList: 'pass/users',
  tmCompanyAccount: 'companyaccount',
  questionList: 'documents',
  tmInstallerPassFirst: 'pass/first',
  tmInstallerPassAdd: 'pass/add',
  tmInstallerPassEdit: 'pass/edit',
  tmInstallerPassAdmin: 'pass/admin/edit',
  tmInstallerPassList: 'pass/list',
  tmInstallerPassListAdmin: 'pass/admin',
  tmImportTechnician: 'import',
  tmWorkflowRule: 'workflow-rule',

  // activation-Management
  cmPrefix: 'cm', // Only use on loading children in routing

  cmCommissioningManagement: 'commissioning',

  cmAdminMeteringConceptList: 'meteringconcepts',

  // Grid Registration
  cmGridRegistration: 'gridregistration',
  cmGridRegistrationNext: 'grid-registration-next',
  cmGridFeeder: 'feeder',
  cmGridCharger: 'charger',
  cmGridEHeating: 'eheating',
  cmGridMisc: 'misc',

  cmCompCat: 'compensation-category',

  tmValidatePass: 'validatePass/:token',
  cssPrefix: 'css',
  cssDashboard: 'dashboard',
  cssAdminConfiguration: 'admin-configuration',
  cssTransactionMonitor: 'transaction-monitor',
  cssSynchronizationOverview: 'synchronization-overview',
  cssSynchronizationDebug: 'synchronization-debug',
  cssQuartzJobs: 'quartz-jobs',
  cssFeatureActivation: 'feature-activation',
  cssUserDetailsList: 'user-details',
  cssTexts: 'texts',
  cssCockpitConfiguration: 'cockpit-configuration',
  cssProcessConfiguration: 'process-configuration',
  cssGenericProcessConfiguration: 'process-configuration',
  cssStandaloneOverview: 'standalone-overview',
  cssArchiveOverview: 'archive-overview',
  cssMarketPrices: 'market-prices',
  cssTenantConfiguration: 'tenant-configuration',
  cssLegalForms: 'legal-forms',
  cssAcademicTitles: 'academic-titles',
  cssContactReasons: 'contact-reasons',
  cssBookingCircles: 'booking-circles',
  cssNumberRanges: 'number-ranges',
  cssSalutations: 'salutations',
  cssLiefHand: 'lief-hand',
  cssTarifTyp: 'tarif-typ',
  cssReadingCause: 'reading-cause',
  cssFreeDay: 'free-day',
  cssPostboxUpload: 'postbox-upload',
  chat: 'chat',

  cmFeederContract: 'feeder-contract',
  cmFeederContractV2: 'feeder-contract-v2',
  grAssignTechnician: 'gr-assign-technician',
  grTransferToTechnician: 'gr-transfer-to-technician',
  grRefreshValidity: 'gr-refresh-validity',

  // price-calculation
  priceCalculationPrefix: 'price-calculation',
  priceCalculation: '',

  // template-management
  templateManagementPrefix: 'template-management',
  templateList: 'template-list',
  templateDetail: 'template-detail',
  templateEditor: 'template-editor',
  templateEmailTest: 'template-email-test',

  message: '/:message',
  goToThanksPage: NavigateToEnum.goToThanksPage,
  goToErrorPage: NavigateToEnum.goToErrorPage,
  cmFCContractConfirmation: 'fc-contract-confirmation',
  cmCRChimneySweepConfirmation: 'cr-chimney-sweep-confirmation',
  cmGRPlaceInServiceConfirmation: 'gr-place-in-service-confirmation',
  hapApproval: 'order-request-approval',
  cmGRConfirmFeedinOrder: 'gr-confirm-feedin-order',
  hapDesktop: 'desktop',
  hapHome: '/home',
  pluginGrFeedback: '/plugin-gr-feedback',
  addressSenseLocalStreets: 'local-streets',
  addressSensePrefix: 'address-sense'
};
